var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import { useRef } from 'react';
import { useChange, useEventCallback, useEventListener, usePrevious, useRefState, } from '../../../foundation';
export var useTooltipForceHide = function (_a) {
    var tooltipForceHide = _a.tooltipForceHide, openProp = _a.open, onClose = _a.onClose, onOpen = _a.onOpen, ref = _a.ref;
    var _b = __read(useRefState(false), 2), openRef = _b[0], setOpen = _b[1];
    var isOverRef = useRef(false);
    var openState = tooltipForceHide ? false : openProp !== null && openProp !== void 0 ? openProp : openRef.current;
    var prevOpenState = usePrevious(function () { return openState; });
    useChange(function () {
        // * when switch to not tooltipForceHide and that mouse keep on element should show tooltip
        if (tooltipForceHide === false && isOverRef.current === true) {
            // * check is that have set open by props, if not set true directly
            openState = openProp !== null && openProp !== void 0 ? openProp : true;
        }
        if (tooltipForceHide && prevOpenState) {
            setOpen(false, false);
            onClose === null || onClose === void 0 ? void 0 : onClose({});
        }
        else if (openState) {
            setOpen(true, false);
            onOpen === null || onOpen === void 0 ? void 0 : onOpen({});
        }
    }, function () { return tooltipForceHide; });
    useEventListener(ref, 'mouseover', function () { return (isOverRef.current = true); });
    var leaveFn = function () { return (isOverRef.current = false); };
    useEventListener(ref, 'mouseleave', leaveFn);
    // * also need blur check for when item become pointer-event none
    useEventListener(ref, 'blur', leaveFn);
    var handleOpen = useEventCallback(function (event) {
        setOpen(true);
        onOpen === null || onOpen === void 0 ? void 0 : onOpen(event);
    });
    var handleClose = useEventCallback(function (event) {
        setOpen(false);
        onClose === null || onClose === void 0 ? void 0 : onClose(event);
    });
    return tooltipForceHide !== undefined
        ? {
            disableFocusListener: tooltipForceHide,
            disableHoverListener: tooltipForceHide,
            disableTouchListener: tooltipForceHide,
            open: openState,
            onOpen: handleOpen,
            onClose: handleClose,
        }
        : undefined;
};
